var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8124 0C5.50865 0 2.15625 4.00145 2.15625 8.36459C2.15625 10.3881 3.29768 12.9114 5.12482 13.7117C5.40227 13.8356 5.55321 13.7829 5.61503 13.528C5.66966 13.3344 5.90973 12.4016 6.02617 11.9616C6.06211 11.8206 6.04342 11.6982 5.92842 11.5658C5.32177 10.8708 4.84018 9.6049 4.84018 8.41728C4.84018 5.37419 7.2826 2.41938 11.4386 2.41938C15.0325 2.41938 17.5468 4.73196 17.5468 8.03992C17.5468 11.7779 15.55 14.3639 12.9552 14.3639C11.5191 14.3639 10.4496 13.2475 10.7888 11.8662C11.1985 10.2215 12.0021 8.45288 12.0021 7.26669C12.0021 6.20296 11.3955 5.32292 10.1563 5.32292C8.69429 5.32292 7.5083 6.75689 7.5083 8.68215C7.5083 9.90536 7.94532 10.7313 7.94532 10.7313C7.94532 10.7313 6.49913 16.5184 6.23031 17.5993C5.77604 19.4291 6.29212 22.3924 6.33669 22.6473C6.364 22.7883 6.52357 22.8325 6.6127 22.7171C6.75502 22.532 8.5031 20.0613 8.99331 18.2757C9.17156 17.6249 9.90328 14.9862 9.90328 14.9862C10.3849 15.8477 11.775 16.5697 13.2557 16.5697C17.6604 16.5697 20.8431 12.7349 20.8431 7.97584C20.8273 3.41333 16.8855 0 11.8124 0Z",
    fill: "#D32F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22.783,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestP);
export default __webpack_public_path__ + "static/media/pinterest-p.d60bc849dc8c22cd70e9b72895067773.svg";
export { ForwardRef as ReactComponent };